/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-filename-extension */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import likely from 'ilyabirman-likely';
import { Timetable } from '../timetable';
import './styles.css';

const Footer = () => {
  const location = window.location.pathname;
  useEffect(() => {
    likely.initiate();
  }, []);

  return (
    <div className="lyt-footer" id="footer">
      <div className="footer">
        <div className="footer_content container">
          <div className="footer_row">
            <ul className="footer_menu">
              <li className="footer_menu-item">
                <a href="https://barashek.ru" className="footer_menu-link">
                  Главная
                </a>
              </li>
              <li className="footer_menu-item">
                <Link
                  to="/"
                  className={`footer_menu-link${
                    location === '/' ? ' is-active' : ''
                  }`}
                >
                  Меню
                </Link>
              </li>
              <li className="footer_menu-item">
                <Link
                  to="/payment"
                  className={`footer_menu-link${
                    location === '/payment' ? ' is-active' : ''
                  }`}
                >
                  Оплата&nbsp;и&nbsp;доставка
                </Link>
              </li>
              <li className="footer_menu-item">
                <Link
                  to="/contacts"
                  className={`footer_menu-link${
                    location === '/contacts' ? ' is-active' : ''
                  }`}
                >
                  Контакты
                </Link>
              </li>
              <li className="footer_menu-item">
                <Link
                  to="/kazanplova"
                  className={`footer_menu-link${
                    location === '/kazanplova' ? ' is-active' : ''
                  }`}
                >
                  Плов&nbsp;в&nbsp;казане
                </Link>
              </li>
            </ul>
            <div className="footer_contacts">
              <div className="footer_contacts-line">
                <span className="footer_contacts-phones">
                  <a className="phone-link" href="tel:+78362369999">
                    +7&nbsp;(8362)&nbsp;36&nbsp;99&nbsp;99
                  </a>
                </span>
              </div>
              <div className="footer_contacts-line">
                <span className="footer_contacts-sked">
                  424033, Республика Марий Эл, г Йошкар-Ола, б-р Чавайна, д 23А,
                  2 этаж
                </span>
              </div>
              <div className="footer_contacts-line">
                <span className="footer_contacts-sked">
                  Прием заказов:&nbsp;
                  <Timetable today />
                </span>
              </div>
            </div>
            <div className="footer_email">
              <a href="mailto:info@barashek.ru" title="email info@barashek.ru">
                info@barashek.ru
              </a>
              <div className="blogs">
                <span className="blogs_title">Мы в соцсетях:</span>
                <a
                  className="blogs_link"
                  href="https://vk.com/barashek"
                  title="barashek vkcom"
                >
                  <svg
                    className="blogs_link-icon icon-vkcom"
                    height="20px"
                    version="1.1"
                    viewBox="0 0 20 20"
                    width="20px"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <title>vk</title>
                    <defs />
                    <g
                      fillRule="evenodd"
                      id="Mobile"
                      stroke="none"
                      strokeWidth="1"
                    >
                      <g
                        id="Guide"
                        transform="translate(-704.000000, -930.000000)"
                      >
                        <g
                          id="vkicon"
                          transform="translate(704.000000, 930.000000)"
                        >
                          <path
                            d="M3.07412981,0.0480769231 L16.8758125,0.0480769231 C18.5735529,0.0480769231 19.9499471,1.42442308 19.9499471,3.12221154 L19.9499471,16.9238942 C19.9499471,18.6216346 18.5735529,19.9980288 16.8758125,19.9980288 L3.07412981,19.9980288 C1.37638942,19.9980288 -4.80769268e-06,18.6216346 -4.80769268e-06,16.9238942 L-4.80769268e-06,3.12221154 C-4.80769268e-06,1.42442308 1.37638942,0.0480769231 3.07412981,0.0480769231"
                            id="vkiconbg"
                          />
                          <path
                            d="M9.80759615,14.0136731 L10.6236538,14.0136731 C10.6236538,14.0136731 10.8700962,13.9865096 10.9961058,13.8508846 C11.1119231,13.7262692 11.1082212,13.4924231 11.1082212,13.4924231 C11.1082212,13.4924231 11.0922596,12.3974712 11.6003846,12.2361731 C12.1014904,12.0772788 12.7448077,13.2944904 13.4266346,13.7625192 C13.9422596,14.1166538 14.3340865,14.0391058 14.3340865,14.0391058 L16.1574038,14.0136731 C16.1574038,14.0136731 17.1111538,13.9547788 16.6588942,13.2049231 C16.621875,13.143625 16.3954327,12.6502115 15.3031731,11.6363654 C14.1598077,10.5751635 14.3130769,10.7468942 15.6902404,8.91136538 C16.5289423,7.79352885 16.8641827,7.111125 16.7594231,6.81881731 C16.6595673,6.54035577 16.0426923,6.61391346 16.0426923,6.61391346 L13.9898077,6.62665385 C13.9898077,6.62665385 13.8375,6.60588462 13.7247115,6.67343269 C13.614375,6.73939423 13.5435577,6.893625 13.5435577,6.893625 C13.5435577,6.893625 13.2185096,7.758625 12.7853365,8.49434615 C11.8712019,10.0465096 11.505625,10.1286731 11.3562019,10.0321827 C11.0085096,9.80751923 11.0954327,9.12982692 11.0954327,8.64819231 C11.0954327,7.14386538 11.3236058,6.51670192 10.6511058,6.35434615 C10.4279808,6.30045192 10.2636058,6.26482692 9.69288462,6.25905769 C8.96033654,6.25155769 8.34048077,6.26126923 7.98942308,6.43324038 C7.75586538,6.54766346 7.57567308,6.80242308 7.68548077,6.81713462 C7.82120192,6.83521154 8.12841346,6.90006731 8.29129808,7.12170192 C8.50173077,7.408 8.494375,8.05069231 8.494375,8.05069231 C8.494375,8.05069231 8.61528846,9.82146154 8.21201923,10.0414135 C7.93538462,10.1922788 7.55576923,9.88425 6.74072115,8.47598077 C6.32326923,7.75468269 6.00793269,6.95723077 6.00793269,6.95723077 C6.00793269,6.95723077 5.94721154,6.80824038 5.83875,6.72843269 C5.70721154,6.63184615 5.52341346,6.60117308 5.52341346,6.60117308 L3.57254808,6.61391346 C3.57254808,6.61391346 3.27975962,6.62213462 3.17216346,6.74944231 C3.07644231,6.86280769 3.16451923,7.09703846 3.16451923,7.09703846 C3.16451923,7.09703846 4.69173077,10.6702115 6.42115385,12.4708365 C8.00706731,14.1220385 9.80759615,14.0136731 9.80759615,14.0136731"
                            fill="#FFFFFF"
                            id="vkicontext"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
                {/*<a*/}
                {/*  className="blogs_link"*/}
                {/*  href="https://instagram.com/barashekru"*/}
                {/*  title="barashek instagram"*/}
                {/*>*/}
                {/*  <svg*/}
                {/*    className="blogs_link-icon icon-inst"*/}
                {/*    enableBackground="new 0 0 20 20"*/}
                {/*    height="20px"*/}
                {/*    version="1.1"*/}
                {/*    viewBox="0 0 20 20"*/}
                {/*    width="20px"*/}
                {/*    x="0px"*/}
                {/*    xmlSpace="preserve"*/}
                {/*    xmlns="http://www.w3.org/2000/svg"*/}
                {/*    xmlnsXlink="http://www.w3.org/1999/xlink"*/}
                {/*    y="0px"*/}
                {/*  >*/}
                {/*    <g>*/}
                {/*      <defs>*/}
                {/*        <path*/}
                {/*          d="M20,15.5c0,2.475-2.025,4.5-4.5,4.5h-11C2.025,20,0,17.975,0,15.5v-11C0,2.025,2.025,0,4.5,0h11    C17.975,0,20,2.025,20,4.5V15.5z"*/}
                {/*          id="SVGID_1_"*/}
                {/*        />*/}
                {/*      </defs>*/}
                {/*      <clipPath id="SVGID_2_">*/}
                {/*        <use overflow="visible" xlinkHref="#SVGID_1_" />*/}
                {/*      </clipPath>*/}
                {/*      <radialGradient*/}
                {/*        cx="1.1401"*/}
                {/*        cy="18.9092"*/}
                {/*        gradientTransform="matrix(1.0217 0 0 1 0.0047 0)"*/}
                {/*        gradientUnits="userSpaceOnUse"*/}
                {/*        id="SVGID_3_"*/}
                {/*        r="25.5414"*/}
                {/*      >*/}
                {/*        <stop offset="0" style={{ stopColor: '#FEC053' }} />*/}
                {/*        <stop*/}
                {/*          offset="0.3273"*/}
                {/*          style={{ stopColor: '#F2203E' }}*/}
                {/*        />*/}
                {/*        <stop*/}
                {/*          offset="0.6485"*/}
                {/*          style={{ stopColor: '#B729A8' }}*/}
                {/*        />*/}
                {/*        <stop offset="1" style={{ stopColor: '#5342D6' }} />*/}
                {/*      </radialGradient>*/}
                {/*      <path*/}
                {/*        clipPath="url(#SVGID_2_)"*/}
                {/*        d="M20.267,17.802c0,1.214-1.007,2.198-2.247,2.198H1.988   c-1.24,0-2.245-0.984-2.245-2.198V2.111c0-1.214,1.005-2.198,2.245-2.198H18.02c1.24,0,2.247,0.984,2.247,2.198V17.802z"*/}
                {/*        fill="url(#SVGID_3_)"*/}
                {/*        id="insticonbg"*/}
                {/*      />*/}
                {/*    </g>*/}
                {/*    <g>*/}
                {/*      <path*/}
                {/*        d="M10,3.926c1.979,0,2.213,0.007,2.994,0.043c0.723,0.033,1.114,0.154,1.376,0.255   c0.346,0.134,0.593,0.295,0.852,0.554c0.26,0.259,0.42,0.506,0.555,0.852c0.102,0.261,0.222,0.654,0.255,1.376   c0.035,0.781,0.043,1.016,0.043,2.994s-0.008,2.213-0.043,2.994c-0.033,0.723-0.153,1.115-0.255,1.376   c-0.135,0.346-0.295,0.593-0.555,0.852c-0.259,0.259-0.506,0.42-0.852,0.554c-0.262,0.102-0.653,0.223-1.376,0.256   c-0.781,0.035-1.016,0.043-2.994,0.043s-2.213-0.008-2.994-0.043c-0.723-0.033-1.114-0.154-1.376-0.256   c-0.346-0.134-0.593-0.295-0.852-0.554c-0.26-0.259-0.42-0.506-0.555-0.852c-0.102-0.261-0.222-0.653-0.255-1.376   C3.934,12.213,3.926,11.979,3.926,10s0.008-2.213,0.043-2.994C4.002,6.284,4.122,5.891,4.224,5.63   c0.135-0.346,0.295-0.592,0.555-0.852c0.259-0.259,0.506-0.42,0.852-0.554c0.262-0.102,0.653-0.222,1.376-0.255   C7.787,3.933,8.021,3.926,10,3.926 M10,2.591c-2.013,0-2.265,0.008-3.055,0.044C6.156,2.671,5.618,2.796,5.146,2.979   c-0.487,0.189-0.9,0.443-1.312,0.854C3.422,4.246,3.169,4.659,2.979,5.146c-0.183,0.471-0.309,1.01-0.345,1.799   C2.6,7.735,2.591,7.988,2.591,10c0,2.012,0.009,2.265,0.044,3.055c0.036,0.789,0.162,1.328,0.345,1.799   c0.189,0.487,0.442,0.9,0.854,1.312s0.825,0.665,1.312,0.854c0.472,0.183,1.01,0.309,1.799,0.345   C7.735,17.4,7.987,17.409,10,17.409s2.265-0.009,3.055-0.044c0.789-0.036,1.327-0.162,1.799-0.345   c0.487-0.189,0.9-0.442,1.312-0.854s0.665-0.825,0.854-1.312c0.183-0.471,0.309-1.01,0.345-1.799   c0.036-0.79,0.044-1.043,0.044-3.055c0-2.012-0.008-2.265-0.044-3.055c-0.036-0.789-0.162-1.328-0.345-1.799   c-0.189-0.487-0.442-0.9-0.854-1.312c-0.412-0.412-0.825-0.665-1.312-0.854c-0.472-0.183-1.01-0.309-1.799-0.344   C12.265,2.599,12.013,2.591,10,2.591L10,2.591z"*/}
                {/*        fill="#FFFFFF"*/}
                {/*      />*/}
                {/*      <path*/}
                {/*        d="M10,6.195c-2.102,0-3.805,1.703-3.805,3.805S7.898,13.805,10,13.805s3.805-1.703,3.805-3.805   S12.102,6.195,10,6.195z M10,12.47c-1.364,0-2.47-1.105-2.47-2.47S8.636,7.53,10,7.53s2.47,1.105,2.47,2.47S11.364,12.47,10,12.47z   "*/}
                {/*        fill="#FFFFFF"*/}
                {/*      />*/}
                {/*      <circle cx="13.956" cy="6.045" fill="#FFFFFF" r="0.889" />*/}
                {/*    </g>*/}
                {/*  </svg>*/}
                {/*</a>*/}
              </div>
            </div>
          </div>
          <div className="footer_row">
            <div className="footer_copy">
              <div className="footer_copy-line">
                Оплата происходит с использованием сервиса&nbsp;
                <a
                  className="logos-paw"
                  href="http://payanyway.ru"
                  title="PayAnyWay"
                >
                  <img alt="" src="/i/layout/paw.svg" />
                </a>
              </div>
              <div className="footer_copy-line">
                Никакие данные на&nbsp;сайте не&nbsp;являются публичной офертой.
              </div>
            </div>
            <div className="footer_social">
              <div className="likely likely-light">
                {/*<div className="twitter" data-url="#">*/}
                {/*  Твитнуть*/}
                {/*</div>*/}
                {/*<div className="facebook" data-url="#">*/}
                {/*  Поделиться*/}
                {/*</div>*/}
                <div className="vkontakte" data-url="#">
                  Поделиться
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
